import { render, staticRenderFns } from "./AIVDialog.vue?vue&type=template&id=ca7a4a52"
import script from "./AIVDialog.vue?vue&type=script&lang=js"
export * from "./AIVDialog.vue?vue&type=script&lang=js"
import style0 from "./AIVDialog.vue?vue&type=style&index=0&id=ca7a4a52&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports